import { MousePointerClick } from 'lucide-preact'
import { text } from '#contract'
import { useView } from '../app/use-view.ts'
import { useT } from '../i18n/index.ts'
import styles from './capture-hint.module.css'

/**
 * Shown while playing with keyboard and mouse but without pointer lock, e.g. when the
 * browser refused an immediate relock. Click-through, so the click reaches the canvas.
 */
export function CaptureHint() {
  const t = useT()
  const shown = useView(
    (view) => view.input.device === 'keyboardMouse' && !view.input.pointerLocked,
  )
  if (!shown) return null

  return (
    <p class={styles.hint}>
      <MousePointerClick class={styles.icon} aria-hidden="true" />
      {t(text('hud.captureHint'))}
    </p>
  )
}
